import React from "react";
import PropTypes from "prop-types";

import Grid from "@material-ui/core/Grid";
import { createMuiTheme, MuiThemeProvider } from "@material-ui/core/styles";
import { gridItemSpacing } from "../../helpers/materialUI";

export const gridThemeStylesSpacing = [
    0,
    8,
    10,
    16,
    20,
    24,
    32,
    36,
    40,
    48,
    64,
    98,
    128
];

export const gridThemeStyles = createMuiTheme({
    spacing: gridThemeStylesSpacing,
    breakpoints: {
        values: {
            xs: 0,
            sm: 0,
            md: 768,
            lg: 1200,
            xl: 1440
        }
    }
});

export const MaterialUIGridContainer = ({
    className,
    children,
    mobileMaxPadding,
    tabletMaxPadding,
    desktopMinPadding,
    justify,
    alignItems
}) => {
    return (
        <MuiThemeProvider theme={gridThemeStyles}>
            <Grid
                container
                className={className}
                justify={justify}
                alignItems={alignItems}
                spacing={gridItemSpacing({
                    mobileMaxPadding,
                    tabletMaxPadding,
                    desktopMinPadding
                })}
            >
                {children}
            </Grid>
        </MuiThemeProvider>
    );
};

MaterialUIGridContainer.propTypes = {
    mobileMaxPadding: PropTypes.number,
    tabletMaxPadding: PropTypes.number,
    desktopMinPadding: PropTypes.number,
    justify: PropTypes.string,
    alignItems: PropTypes.string
};

// {children} should be Material UI Grid items: <Grid item> .. </GridItem>
